const palette = {

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * List of emojis to display.
	 *
	 * @type {array}
	 */
	emoji: [ '⬜️', '⬛️', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '🟫', '🔲', '🔳' ],


	/**
	 * Emojis to block/ exclude.
	 *
	 * @type {array}
	 */
	emoji_exclude: [ '🖕', '🖕🏻', '🖕🏼', '🖕🏽', '🖕🏾', '🖕🏿' ],


	/**
	 * An array of emoji categories.
	 *
	 * @type {array}
	 */
	emoji_categories: null,


	/**
	 * The search element.
	 *
	 * @type {object}
	 */
	$search: null,


	/**
	 * Debounce the search queries.
	 *
	 * @type {null|object}
	 */
	searchTimer: null,


	/**
	 * Fuzzy search.
	 *
	 * @type {object}
	 */
	fuse: null,


	/**
	 * Debounce the drawing updates.
	 *
	 * @type {null|object}
	 */
	timerUpdateDrawing: null,


	/**
	 * A list of the colours in the drawing.
	 *
	 * @type {array}
	 */
	drawingPalette: [],


	/**
	 * Count the items in the emoji categories.
	 *
	 * @type {array}
	 */
	groupCount: [],


	/**
	 * Initialize the component.
	 *
	 * @return {void}
	 */
	init: function() {

		// Remove palette.emoji_exclude from emojiListFull.
		emojiListFull = emojiListFull.filter( item => !palette.emoji_exclude.includes( item.e ) );

		// Initialize the fuzzy search.
		palette.fuse = new Fuse(
			emojiListFull,
			{
				keys: [ 'n' ],
				minMatchCharLength: 2,
				threshold: 0.2,
			}
		);

		emojiListFull.forEach(
			( item ) => {
				if ( palette.groupCount[ item.g ] ) {
					palette.groupCount[ item.g ]++;
				} else {
					palette.groupCount[ item.g ] = 1;
				}
			}
		);

		const $comp = document.querySelector( '.emoji-palette' );

		palette.app = new Reef(
			$comp,
			{
				data: {
					paletteSearch: '',
				},
				template: palette.template,
			}
		);

		palette.app.render();

		$comp.addEventListener( 'click', palette.click );

		palette.$search = document.getElementById( 'palette-search' );
		palette.$search.addEventListener( 'keyup', palette.searchChange );

		document.addEventListener( 'updateDrawing', palette.maybeUpdateDrawing );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		let html = '';

		html += palette.emoji_picker_categories();
		html += '<section class="w100 flex-g1">';
		html += palette.emoji_picker_search();
		html += palette.emoji_picker_list( ninjaData.data.currentEmoji );
		html += '</section>';

		return html;

	},


	/**
	 *
	 */
	emoji_picker_search: function() {

		let html = '';

		html += `<input
			type="search"
			placeholder="Search..."
			id="palette-search"
			class="mw5"
			results="5"
			value="${palette.app.data.paletteSearch}"
		/>`;

		return `<div class="position-s p3">${html}</div>`;

	},


	/**
	 * List the emoji picker categories.
	 *
	 * @return {string}
	 */
	emoji_picker_categories: function() {

		let html = '';

		// Add the non category links.
		html += palette.emojiCategoryLinkHTML( 'This Image' );
		html += palette.emojiCategoryLinkHTML( 'Pixel Art' );

		// Add the actual category links.
		emojiGroups.forEach(
			( item, index ) => {
				if ( palette.groupCount[ index ] > 0 ) {
					html += palette.emojiCategoryLinkHTML( item );
				}
			}
		);

		return `<nav
			class="p3 flex flex-wrap w3"
		>${html}</nav>`;

	},


	/**
	 * Display the list of emojis.
	 *
	 * @param {string} currentEmoji The currently selected emoji.
	 * @return {string} The html for the emoji list.
	 */
	emoji_picker_list: function( currentEmoji ) {

		let html = '';

		const { paletteSearch } = palette.app.data;

		// Is there a search happening?
		if ( paletteSearch ) {

			const searchResults = palette.fuse.search( paletteSearch );

			if ( searchResults.length <= 0 ) {

				// No search results.
				html += `<strong class="display-block m-t3">Can't find emojis for <em>"${sanitize.html( paletteSearch )}</em>".</strong>`;

			} else {

				// Display Search Results.
				searchResults.forEach(
					( value ) => {
						// console.log( value );
						html += palette.emojiButtonHTML( value.item, currentEmoji );
					}
				);

			}

		} else {

			if ( palette.drawingPalette.length <= 0 ) {
				palette.updateDrawingPalette();
			}

			html += palette.displayEmojiGroup( 'This Image', currentEmoji, null, palette.drawingPalette );
			html += palette.displayEmojiGroup( 'Pixel Art', currentEmoji, null, palette.emoji );

			// Default Emoji List.
			emojiGroups.forEach(
				( item, group_index ) => {

					html += palette.displayEmojiGroup( item, currentEmoji, group_index );

				}
			);

		}

		return `<div
			id="emoji-list"
			class="p3 mh6 overflow scroll-smooth flex-g1"
		>${html}</div>`;

	},


	/**
	 * Display a group of emojis with heading.
	 * Generates the required html.
	 *
	 * @param {string} name The name of the group. Slugified this is also the group array key.
	 * @param {string} currentEmoji The current emoji.
	 * @param {string} group_index The current group to display.
	 * @param {array} emoji_list The list of emojis to display.
	 * @return {string} The html for the emoji group.
	 */
	displayEmojiGroup: function( name, currentEmoji, group_index = null, emoji_list = emojiListFull ) {

		let html = '';

		if ( null !== group_index ) {
			if ( !palette.groupCount[ group_index ] || palette.groupCount[ group_index ] <= 0 ) {
				return html;
			}
		}

		const slug = urlString( name );

		// Category heading.
		html += `<strong
			id="category-${slug}"
			class="display-block m-t3"
		>${name}</strong>`;

		// Loop through all emoji.
		emoji_list.forEach(
			( value, index ) => {

				if ( undefined === value.g ) {
					value = {
						e: value,
						n: '',
						g: group_index
					};
				}

				if ( group_index === value.g ) {
					html += palette.emojiButtonHTML( value, currentEmoji );
				}

			}
		);

		return html;

	},


	/**
	 * Generate a link that points to a category in the emoji list.
	 *
	 * @param {string} category The category name to link to.
	 * @return {string} The link html.
	 */
	emojiCategoryLinkHTML: function( category ) {

		const slug = urlString( category );

		return `<a
			href="#category-${slug}"
			data-id="${slug}"
			class="w2 flex-g1"
			title="Emojis for ${category}"
		>
			<img src="/assets/images/emoji-categories/${slug}.svg" alt="*" />
		</a>`;

	},


	/**
	 * Display a category button.
	 *
	 * @param {object} emoji Information about the current emoji.
	 * @param {string} currentEmoji The currently selected emoji.
	 * @return {string} The button html.
	 */
	emojiButtonHTML: function( emoji, currentEmoji ) {

		let buttonClass = '';

		if ( emoji.e === currentEmoji ) {
			buttonClass = 'selected';
		}

		return `<button
			data-emoji="${emoji.e}"
			type="button"
			title="${emoji.n}"
			class="ar-1 button button-emoji ${buttonClass}">${emoji.e}</button>`;

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		e.preventDefault();
		e.stopPropagation();

		const htmlType = e.target.nodeName;

		/**
		 * Category anchors.
		 */
		if ( 'A' === htmlType ) {

			/**
			 * When we click a category link lets clear the search box to ensure
			 * the selected category is visible.
			 */
			palette.app.setData(
				{
					paletteSearch: ''
				}
			);

			document.getElementById( 'palette-search' ).value = '';

			const href = e.target.getAttribute( 'href' );
			scrollToTop( document.querySelector( href ), document.querySelector( '.emoji-palette div#emoji-list' ) );
			return;

		}

		if ( 'BUTTON' !== htmlType ) {
			return;
		}

		/**
		 * Update the currently selected emoji.
		 */
		const target = e.target;
		const emoji = target.getAttribute( 'data-emoji' );

		if ( !emoji ) {
			return;
		}

		ninjaData.setData(
			{
				currentEmoji: emoji
			}
		);

		palette.app.render();

	},


	/**
	 * Debounce the search engine changes.
	 *
	 * @param {event} e The event changes.
	 * @return {void}
	 */
	searchChange: function( e ) {

		clearTimeout( palette.searchTimer );
		palette.searchTimer = setTimeout( palette.searchEmoji, 400 );

	},


	/**
	 * Change the current search parameters.
	 *
	 * @return {void}
	 */
	searchEmoji: function() {

		const query = palette.$search.value.toLowerCase();

		palette.app.setData(
			{
				'paletteSearch': query
			}
		);

	},


	/**
	 * Debounce palette updates.
	 *
	 * @param {event} e The listener event.
	 * @return {void}
	 */
	maybeUpdateDrawing: function( e ) {

		clearTimeout( palette.timerUpdateDrawing );
		palette.timerUpdateDrawing = setTimeout( palette.updateDrawingPalette, 1000 );

	},


	/**
	 * Update the drawing palette if it has changed.
	 *
	 * @return {void}
	 */
	updateDrawingPalette: function() {

		const tempPalette = drawing.getArtEmojis();

		if ( JSON.stringify( tempPalette ) !== JSON.stringify( palette.drawingPalette ) ) {
			palette.drawingPalette = tempPalette;
			palette.app.render();
		}

	},

};
